import { Injectable } from '@angular/core';
import { TenantSummary, CreateTenantRequest, CreateTenantResponse } from '../models/tenant-admin.model';
import { AdminCommonHttpService } from './admin-common-http.service';

@Injectable({ providedIn: 'root' })
export class TenantAdminService {
  constructor(private httpService: AdminCommonHttpService) { }

  listTenants(): Promise<TenantSummary[]> {
    return this.httpService.getTenantList();

  }

  createTenant(payload: CreateTenantRequest): Promise<any> {
    // return this.http.post<any>(`/admin/tenant/create`, payload).then((res: any) => res ?? {});
    return this.httpService.createTenant(payload);
  }

  suspendTenant(tenantId: string): Promise<any> {
    const payload = { tenant_id: tenantId };
    return this.httpService.suspendTenant(payload);
  }

  activateTenant(tenantId: string): Promise<any> {
    const payload = { tenant_id: tenantId };
    return this.httpService.activateTenant(payload);
  }

  async rotateApiKey(tenantId: string): Promise<any> {
    const payload = {
      tenant_id: tenantId,
      scopes: ["cart:create", "cart:get", "order:create"],
      expires_at: '2027-01-01T00:00:00Z'
    };
    const respObject = await this.httpService.rotateTenantKey(payload);
    return JSON.parse(respObject).api_key;
  }
}
